import React, { useState, useEffect, useRef } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import FilterTrigger from "../../commons/FilterTrigger/FilterTrigger";
import FilterOptionsMenu from "../../commons/FilterOptionsMenu/FilterOptionsMenu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import TablePagination from "../../commons/Pagination/TablePagination";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

const DRIVER_NAME_MAX_LENGTH = 50;

const formatDriverName = (name) => {
  if (!name) return "-";
  if (name.length <= DRIVER_NAME_MAX_LENGTH) return name;
  return `${name.slice(0, DRIVER_NAME_MAX_LENGTH)}...`;
};

function DriverManagment() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [filter, setFilter] = useState("All");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterRef = useRef(null);


  const filterTypeMap = {
    "All": "",
    "In-House": 1,
    "External": 2,
  };

  const getList = async () => {
    setLoading(true);
    try {
      const trimmedSearch = search.trim();
      let query = {
        page: page,
        limit: limit,
        ...(trimmedSearch && { search: trimmedSearch }),
      };

      const selectedType = filterTypeMap[filter];
      if (selectedType) {
        query.type = selectedType;
      }
      query = new URLSearchParams(query).toString();    
      const response = await handleApiCall("get", `${endpoints.getDriverList}?${query}`);

      if (response?.data?.code === 200) {
        setData(response?.data?.data?.result || []);
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
      }

    } catch (error) {
      setError(true);
      toast.error("Failed to fetch driver list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [cms, page, search, filter]);

  useEffect(() => {
    const listState = location.state?.listState;
    if (!listState) return;

    if (listState.page) setPage(listState.page);
    if (listState.search !== undefined) setSearch(listState.search);
    if (listState.filter) setFilter(listState.filter);
  }, [location.state]);

  const toggleDriverStatus = async (driverId, currentStatus) => {
    if (!driverId) {
      toast.error("Driver ID not found");
      return;
    }
    const newStatus = Number(currentStatus) === 1 ? 0 : 1;
    try {
      const response = await handleApiCall("put", endpoints.updateDriverStatus, {
        driver_id: driverId,
        status: newStatus,
      });
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Driver status updated successfully!");
        getList();
      }
    } catch (error) {
      console.error("Error updating driver status:", error);
    }
  };
  // const deleteTeam = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this team?")) {
  //     try {
  //       const response = await handleApiCall(
  //         "delete",
  //         `${endpoints.teamDelete}?teamId=${id}`
  //       );
  //       if (response?.data?.code === 200) {
  //         toast.success("Team deleted successfully!");
  //         getList();
  //       }
  //     } catch (error) {
  //       toast.error("Error deleting team.");
  //     }
  //   }
  // };
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Driver Managment</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">                
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-4 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder={UI_CONSTANTS.PLACEHOLDERS.DRIVER_SEARCH}
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPage(1);
                        }}
                      />
                    </div>
                  </form>
                  <FilterTrigger
                    ref={filterRef}
                    active={filter !== "All"}
                    className="ms-2"
                    onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                  >
                    {showFilterDropdown && (
                      <FilterOptionsMenu
                        options={["All", "In-House", "External"]}
                        value={filter}
                        style={{ left: "calc(100% + 10px)", top: 0 }}
                        onSelect={(option) => {
                          setFilter(option);
                          setShowFilterDropdown(false);
                          setPage(1);
                        }}
                      />
                    )}
                  </FilterTrigger>
                  <Link to="/add-driver" className="ml-auto btn btn-primary">Add New Driver</Link>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80">Driver ID</th>
                        <th width="150">Name</th>
                        <th>Mobile Number</th>
                        <th>Type</th>
                        <th>Email id</th>
                        <th>Status</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item._id}>
                            <td>#{item?._id?.slice(-8)}</td>
                            <td className="text-center" title={item?.driver?.full_name || ""}>
                              {formatDriverName(item?.driver?.full_name)}
                            </td>
                            <td>
                              +{item?.driver?.country_code} {item?.driver?.phone}
                            </td>
                            <td>
                              {item?.agent_type === 1 ? "In-House" : "External"}
                            </td>
                            <td>
                              {item?.driver?.email || "-"}
                            </td>
                            <td>
                              <span
                                className={`badge ${Number(item?.driver?.status) === 1 ? "badge-success" : "badge-danger"}`}
                              >
                                {Number(item?.driver?.status) === 1 ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <Link
                                  to={`/driver-managment/view-driver/${item?.driver?._id}`}
                                  state={{
                                    from: "/driver-managment",
                                    listState: { page, search, filter },
                                  }}
                                  className="mx-2"
                                >
                                  <img src={viewImage} alt="View" />
                                </Link>

                                <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    checked={Number(item?.driver?.status) === 1}
                                    onChange={() =>
                                      toggleDriverStatus(item?.driver?._id, Number(item?.driver?.status))
                                    }
                                  />
                                  <span className="custom-control-label custom-toggle" />
                                </label>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center py-4">
                            No Drivers Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriverManagment;
